module.exports = __webpack_public_path__ + "assets/img/recommend_icon08.bc14647d.png";